import { ACTION_TYPES, MUTATION_TYPES } from './types';
import certificationLoadService from './../api';

export default {
  async [ACTION_TYPES.RESET](context) {
    context.commit(MUTATION_TYPES.RESET);
  },
  async [ACTION_TYPES.GET_ACADEMIC_YEARS]({ commit }) {
    const result = await certificationLoadService.getAcademicYears();
    commit(MUTATION_TYPES.SET_ACADEMIC_YEARS, result);
  },
  async [ACTION_TYPES.GET_MONTHS](context, payload) {
    const { data: result } = await certificationLoadService.getMonths(payload);
    context.commit(MUTATION_TYPES.SET_MONTHS, result);
  },
  async [ACTION_TYPES.GET_CENTERS](context, { academicYearId, month }) {
    const { data: result } = await certificationLoadService.getCenters(
      academicYearId,
      month
    );
    context.commit(MUTATION_TYPES.SET_CENTERS, result);
  },
  async [ACTION_TYPES.GET_SERVICES](
    context,
    { academicYearId, month, centerId, companyId }
  ) {
    const { data: result } = await certificationLoadService.getServices(
      academicYearId,
      month,
      centerId,
      companyId
    );
    context.commit(MUTATION_TYPES.SET_SERVICES, result);
  },
  async [ACTION_TYPES.GET_SPECIALIST](
    context,
    { academicYearId, month, companyId, centerId, serviceId }
  ) {
    const { data: result } = await certificationLoadService.getSpecialists(
      academicYearId,
      month,
      companyId,
      centerId,
      serviceId
    );
    context.commit(MUTATION_TYPES.SET_SPECIALIST, result);
  },
  async [ACTION_TYPES.GET_STUDENT](
    context,
    {
      academicYearId,
      companyId,
      month,
      centerId,
      disciplineTypeId,
      specialistId,
      statusId,
      therapyDocumentTypeId,
      specialistsOrCompaniesId,
      locationServiceId,
    }
  ) {
    const { data: result } = await certificationLoadService.getStudentSummary(
      academicYearId,
      companyId,
      month,
      centerId,
      disciplineTypeId,
      specialistId,
      statusId,
      therapyDocumentTypeId,
      specialistsOrCompaniesId,
      locationServiceId
    );
    context.commit(MUTATION_TYPES.SET_STUDENT, result);
  },
  async [ACTION_TYPES.UPLOAD_FILES](context, payload) {
    const { data: result } = await certificationLoadService.uploadFiles(
      payload.formData
    );
    if (result) {
      await context.dispatch(ACTION_TYPES.GET_STUDENT, payload.search); //Update Stas
      context.commit(MUTATION_TYPES.SET_UPLOADED_STATUS, result); //Set Errors for not override by searching.
    }
  },
  async [ACTION_TYPES.GET_DOCUMENT_TYPES](context) {
    const { data: result } = await certificationLoadService.getDocumentTypes();
    context.commit(MUTATION_TYPES.SET_DOCUMENT_TYPES, result);
  },
  async [ACTION_TYPES.GET_THERAPY_DOCUMENTS_TYPES]({ commit }) {
    const result = await certificationLoadService.gettherapyDocumentTypes();
    commit(MUTATION_TYPES.SET_THERAPY_DOCUMENTS_TYPES, result);
  },
  async [ACTION_TYPES.GET_SPECIALIST_OR_COMPANY](context, payload) {
    let specialistsOrCompanies = [];
    specialistsOrCompanies = await certificationLoadService.getCompanies(
      payload
    );
    context.commit(
      MUTATION_TYPES.SET_SPECIALIST_OR_COMPANY,
      specialistsOrCompanies
    );
  },
  async [ACTION_TYPES.GET_SPECIALIST_OR_COMPANY_CENTERS](context, payload) {
    let specialistsOrCompanies = [];
    specialistsOrCompanies = await certificationLoadService.getCompanies({
      academicYearId: payload.academicYearId,
      month: payload.month?.name,
    });
    const { data: result } = await certificationLoadService.getCenters(
      payload.academicYearId,
      payload.month?.id
    );

    context.commit(
      MUTATION_TYPES.SET_SPECIALIST_OR_COMPANY,
      specialistsOrCompanies
    );
    context.commit(MUTATION_TYPES.SET_CENTERS, result);
  },
};
